import angular from "angular";
import contract from '../../Contract'
import { vsModuleName as configModuleName } from "./configs/module";
import { vsModuleName as sharedModuleName } from "../shared";
import { vsModuleName as contractModuleName } from "../threeRivers/contracts/module"
import {
  SycuanMachinesComponentsViewsMain,
  vsComponentName as SycuanMachinesComponentsViewsMainName,
} from "./components/views/main/component";
import { routeConfig } from "./routes";
import {
  MachineConfigurationEditFormComponentOptions,
  vsComponentName as MachineConfigurationEditFormComponentName,
} from "./components/machineEditForm";
import {
  CloneAndConversionServiceThreeRivers,
  vsServiceName as CloneAndConversionServiceThreeRiversName,
} from "./services/cloneAndConversionService";
import {
  MachineConfigurationViewDetailComponentOptions,
  vsComponentName as MachineConfigurationViewComponentName,
} from "./components/machineConfigurationDetailView/component";
import {
  machinesMoveViewComponentOptions,
  vsComponentName as machinesMoveViewComponentName,
} from "./components/views/main/move";
import {
  machinesWarehouseMoveViewComponentOptions,
  vsComponentName as machinesWarehouseMoveViewComponentName,
} from "./components/views/main/warehouse";
import {
  machinesDecommissionMoveViewComponentOptions,
  vsComponentName as machinesDecommissionMoveViewComponentName,
} from "./components/views/main/decommission";
import {
  singleMachineMoveComponentOptions,
  vsComponentName as singleMachineMoveComponentName,
} from "./components/views/detail/move/component";
import {
  singleMachineWarehouseComponentOptions,
  vsComponentName as singleMachineWarehouseComponentName,
} from "./components/views/detail/warehouse";
import {
  singleMachineDecommissionComponentOptions,
  vsComponentName as singleMachineDecommissionComponentName,
} from "./components/views/detail/decommission";
import {
  SlotTrakServerAdapter,
  vsName as SlotTrakServerAdapterName,
} from "./slotTrakServerAdapter";

import { vsName as depreciationModuleName } from "../../Depreciation";
import { vsName as processModuleName } from "../../Process";

import { vsModuleName as partsMachinesModuleName } from "../../parts.machines/module";

import {
  vsComponentName as softwareProgramGridComponentName,
  softwareProgramGridComponentOptions,
} from "./components/softwareProgramGrid";
import {
  vsComponentName as machineTypeIdEditComponentName,
  machineTypeIdEditComponentOptions,
} from "./components/views/typeId/edit";
import {
  machineTypeIdInfoComponentOptions,
  vsComponentName as machineTypeIdInfoComponentName,
} from "./components/views/typeId/info";

import { vsModuleName as ProgressivesModuleName } from "../../machines.progressives";
import {
  threeRiversMachineTypeIdDetailViewComponentOptions,
  vsComponentName as threeRiversMachineTypeIdDetailViewComponentName,
} from "./components/machineTypeIdDetailView";
import {
  machineTypeIdInfoMachineComponentOptions,
  vsComponentName as machineTypeIdInfoMachineComponentName,
} from "./components/views/typeId/info/machines";
import {
  machineTypeIdInfoMachineEditComponentOptions,
  vsComponentName as machineTypeIdInfoMachineEditComponentName,
} from "./components/views/typeId/info/machines/edit/component";

export const vsModuleName = "SlotTrak.Machines";
export const vsClientName = "sycuan";
export default vsModuleName;

angular
  .module(vsModuleName, [
    configModuleName,
    sharedModuleName,
    partsMachinesModuleName,
    depreciationModuleName,
    processModuleName,
    ProgressivesModuleName,
    contract,
    contractModuleName,
  ])
  .config(routeConfig)
  .component(
    SycuanMachinesComponentsViewsMainName,
    SycuanMachinesComponentsViewsMain
  )
  .component(
    MachineConfigurationEditFormComponentName,
    MachineConfigurationEditFormComponentOptions
  )
  .component(
    MachineConfigurationViewComponentName,
    MachineConfigurationViewDetailComponentOptions
  )
  .service(
    CloneAndConversionServiceThreeRiversName,
    CloneAndConversionServiceThreeRivers
  )
  .component(machinesMoveViewComponentName, machinesMoveViewComponentOptions)
  .component(
    machinesWarehouseMoveViewComponentName,
    machinesWarehouseMoveViewComponentOptions
  )
  .component(
    machinesDecommissionMoveViewComponentName,
    machinesDecommissionMoveViewComponentOptions
  )
  .component(singleMachineMoveComponentName, singleMachineMoveComponentOptions)
  .component(
    singleMachineWarehouseComponentName,
    singleMachineWarehouseComponentOptions
  )
  .component(
    singleMachineDecommissionComponentName,
    singleMachineDecommissionComponentOptions
  )
  .component(
    softwareProgramGridComponentName,
    softwareProgramGridComponentOptions
  )
  .component(machineTypeIdEditComponentName, machineTypeIdEditComponentOptions)
  .component(machineTypeIdInfoComponentName, machineTypeIdInfoComponentOptions)
  .component(
    threeRiversMachineTypeIdDetailViewComponentName,
    threeRiversMachineTypeIdDetailViewComponentOptions
  )
  .component(
    machineTypeIdInfoMachineComponentName,
    machineTypeIdInfoMachineComponentOptions
  )
  .component(
    machineTypeIdInfoMachineEditComponentName,
    machineTypeIdInfoMachineEditComponentOptions
  )
  .service(SlotTrakServerAdapterName, SlotTrakServerAdapter);
